const blog = {
  blogPage: {
    header: {
      overline: "INSIGHTS & PERSPECTIVES",
      titlePrefix: "The",
      titleHighlight: "Data",
      titleSuffix: "Chronicles",
      subtitle: "Deep dives into Data Science, AI architecture, and the business of building intelligent software.",
    },
    actions: {
      readArticle: "Read Article",
    },
    newsletter: {
      titlePrefix: "Subscribe to",
      titleHighlight: "Deep Dives",
      subtitle: "Get exclusive insights on AI trends and technical architecture directly in your inbox. No spam, just value.",
      namePlaceholder: "Your name",
      emailPlaceholder: "Your email address",
      buttonIdle: "Join the Community",
      buttonLoading: "Joining...",
    },
    validation: {
      requiredFields: "Please fill in all fields.",
    },
    modal: {
      titles: {
        success: "Success!",
        warning: "Heads up",
        error: "Error",
      },
      close: "Close",
      messages: {
        success: "Happy to have you with us, {{name}}! You will soon receive our best insights.",
        alreadySubscribed: "You are already subscribed to our newsletter!",
      },
    },
  },
  blogDetail: {
    errors: {
      load: "Error loading article",
    },
    backToBlog: "Back to Blog",
    suggested: {
      title: "You Might Also Be Interested In",
      readMore: "Read More",
    },
    footerCta: {
      titlePrefix: "Ready to Deepen Your",
      titleHighlight: "Data Expertise?",
      subtitle:
        "Whether you're looking for advanced AI implementations or strategic data advice, I'm here to help you navigate the complex world of data science.",
      primaryButton: "Schedule a Free Call",
      secondaryButton: "Explore Services",
    },
  },
};

export default blog;
